import React from 'react'
import { Box, Link, SxProps } from '@mui/material'
import { useIsMobile } from '../../hooks/useScreenSize'

const Footer: React.FC<{ sx?: SxProps }> = ({ sx }) => {
  const isMobile = useIsMobile()
  return (
    <Box component="footer" sx={{ backgroundColor: 'text.primary', zIndex: 1000, ...sx }}>
      <Box
        sx={{
          width: '100%',
          margin: '0 auto',
          py: isMobile ? 1 : 2,
          color: 'text.contrastText',
          textAlign: 'center',
          fontSize: '12px',
        }}
      >
        ACPG HUB - Developed & Powered by{' '}
        <Link
          href="https://www.belma.gr/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ color: 'text.contrastText', fontWeight: 600 }}
        >
          Belma
        </Link>
      </Box>
    </Box>
  )
}

export default Footer
